import { DYNAMICS_VARIABLE_REGEXP } from ".";

function applyDynamics(src, dynamics) {
  return src.replace(DYNAMICS_VARIABLE_REGEXP, function (fullMatch, variableName) {
    return Object.prototype.hasOwnProperty.call(dynamics, variableName) ? dynamics[variableName] : fullMatch;
  });
}

export { applyDynamics };